import {
  MerchantSetupProductSchema,
  MerchantSetupProgressSchema,
} from "@redotech/redo-onboarding-db-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/**
 * Team-scoped temporary deferral. Sets `deferred_until` so the intake
 * modal stays suppressed until that timestamp passes — different from
 * `dismissMerchantSetupGuide`, which is permanent. The widget reminder
 * keeps showing during the deferral window so the merchant can resume
 * any time without waiting it out.
 *
 * If `untilDate` is omitted the server defaults to a 7-day deferral.
 * The optional client-supplied date is reserved for product-specific
 * deferral lengths in future flows.
 */
export const deferMerchantSetupGuide = {
  name: "deferMerchantSetupGuide" as const,
  input: z.object({
    product: MerchantSetupProductSchema,
    untilDate: z.coerce.date().optional(),
  }),
  output: zExt.filterToValid(MerchantSetupProgressSchema),
};
